export default {
    data: [
        'Mặt tiền',
        'Hẻm ôtô',
        'Hẻm xe máy',
    ]
}